module.exports = __webpack_public_path__ + "img/480a.e6e6166a.png";